export class FeatureItem {

  icon: string;
  name: string;
  fromValue: string;
  toValue: string;
  requests: number;
  tooltip?: string;


  constructor(featureItemData?) {
    if(featureItemData){
      this.icon = featureItemData.icon;
      this.name = featureItemData.name;
      this.fromValue =  featureItemData.fromValue;
      this.toValue = featureItemData.toValue;
      this.requests = featureItemData.requests;
      this.tooltip = featureItemData.tooltip;


      if (featureItemData.fromValue && typeof featureItemData.fromValue === 'number') {
        this.fromValue = `R$ ${featureItemData.fromValue.toFixed(2).replace('.', ',')}`;        
      }
      if (featureItemData.toValue && typeof featureItemData.toValue === 'number') {
        this.toValue = `R$ ${featureItemData.toValue.toFixed(2).replace('.', ',')}`;        
      }
    }
  }
}
